import { render } from "./TableModal.vue?vue&type=template&id=1b7add4e"
import script from "./TableModal.vue?vue&type=script&lang=ts"
export * from "./TableModal.vue?vue&type=script&lang=ts"
script.render = render

export default script